/**
 * Everyday words for word ladders.
 *
 * ENABLE, the validity list, holds every word a word game allows, and a shortest ladder
 * through all of it happily steps through words no pupil knows ("ope", "bey", "rin") or
 * would rather not read aloud. These lists are the common two-, three-, four- and
 * five-letter words a primary or middle-school class meets, and a ladder built from them
 * is a puzzle a person can actually solve. Every word here is also in ENABLE; a test
 * checks that. There is no list for six letters and up, where the full word list is used.
 */

const TWO = [
  "am an as at be by do go he hi if in is it me my no of oh on or so to up us we",
].join(" ");

const THREE = [
  "ace act add age ago aid aim air all and ant any ape arc are arm art ash ask ate bad",
  "bag ban bar bat bay bed bee beg bet bib big bin bit bog bow box boy bud bug bun bus",
  "but buy bye cab can cap car cat cop cot cow cry cub cup cut dad dam day den dew did",
  "die dig dim dip doe dog dot dry dub due dug dye ear eat eel egg elf elk elm end era",
  "eve eye fad fan far fat fax fed fee few fig fin fir fit fix flu fly foe fog for fox",
  "fry fun fur gap gas gel gem get gnu god got gum gut guy gym had ham has hat",
  "hay hem hen her hid him hip his hit hop hot how hub hue hug hum hut ice icy ill ink",
  "inn ion its ivy jab jam jar jaw jay jet jig job jog joy jug keg key kid kin kit lab",
  "lad lag lap law lay led leg let lid lie lip lit log lot low mad man map mat may men",
  "met mid mix mob mop mud mug nap net new nil nip nod nor not now nun nut oak oar oat",
  "odd off oil old one opt orb ore our out owl own pad pal pan par pat paw pay pea peg",
  "pen pet pie pig pin pit pod pop pot pro pub pup put rag ram ran rap rat raw ray red",
  "rib rid rig rim rip rob rod rot row rub rug run rut rye sad sag sat saw say sea",
  "see set sew she shy sin sip sir sit six ski sky sly sob sod son sow soy spa spy sub",
  "sum sun tab tag tan tap tar tax tea ten the tie tin tip toe ton too top tot toy try",
  "tub tug two urn use van vat vet via vow wag war was wax way web wed wee wet who why",
  "wig win wit woe wok won woo wow yak yam yap yes yet yew you zap zip zoo",
].join(" ");

const FOUR_EXTRA = ["soar coop soot"].join(" ");

const FOUR = [
  "able acid aged also area army away baby back ball band bank bare bark barn base bath",
  "bead beak beam bean bear beat beef been bell belt bend bent best bike bill bind",
  "bird bite blow blue boat body boil bold bolt bond bone book boom boot bore born boss",
  "both bowl bulb bulk burn bush busy cafe cage cake call calm came camp card care cart",
  "case cash cast cave cell chat chef chin chip city clam clap claw clay clip club coal",
  "coat code coin cold come cook cool cope copy cord core corn cost cozy crab crew crop",
  "crow cube curl cute dare dark dart dash data date dawn days dead deaf deal dear deck",
  "deed deep deer desk dial dice diet dime dine dirt dish disk dive dock does doll dome",
  "done door dose dove down drag draw drew drip drop drum duck dull dust duty each earn",
  "ease east easy edge else even ever evil exit face fact fade fail fair fall fame farm",
  "fast fate fear feed feel feet fell felt fern file fill film find fine fire firm fish",
  "fist five flag flat flew flip flow foam fold folk food fool foot fork form fort four",
  "free frog from fuel full fund fuse gain game gate gave gear gift girl give glad glow",
  "glue goal goat gold golf gone good gown grab gray grew grid grin grip grow gulf gust",
  "hair half hall hand hang hard harm hate have hawk head heal heap hear heat heel held",
  "help herb here hero hide high hill hint hire hold hole holy home hook hope horn",
  "hose host hour huge hull hung hunt hurt idea inch iron isle item jail jazz jeep join",
  "joke jump junk jury just keen keep kept kick kind king kiss kite knee knew knit",
  "knob knot know lace lack lady laid lake lamb lamp land lane last late lawn lazy lead",
  "leaf leak lean leap left lend lens less lick life lift like lily limb lime line link",
  "lion list live load loaf loan lock loft lone long look loop lord lose loss lost loud",
  "love luck lump lung lush made mail main make male mall many mark mask mass mast mate",
  "math meal mean meat meet melt memo mend menu mere mess mild mile milk mill mind mine",
  "mint miss mist mole moon more moss most moth move much must myth nail name navy near",
  "neat neck need nest news next nice nine node none noon nose note noun once only onto",
  "open oral oven over pace pack page paid pail pain pair pale palm pane park part pass",
  "past path pave peak pear peas peel peer pest pick pier pile pill pine pink pipe plan",
  "play plot plow plug plum plus poem poet pole poll pond pony pool poor pork port pose",
  "post pour pray prey pull pump pure push quit quiz race rack rage raid rail rain rake",
  "ramp rang rank rare rash rate rave read real rear reed reef rent rest rice rich ride",
  "ring riot rise risk road roar robe rock rode role roll roof room root rope rose rude",
  "ruin rule rush rust safe sage said sail sake sale salt same sand sang sank save seal",
  "seat seed seek seem seen self sell send sent shed shin ship shoe shop shot show shut",
  "sick side sigh sign silk sing sink site size skin skip slam slap slid slim slip slot",
  "slow snap snow soak soap sock soda sofa soft soil sold sole some song soon sore sort",
  "soul soup sour span spin spit spot star stay stem step stir stop such suit sung sure",
  "swam swan swim tail take tale talk tall tank tape task taxi team tear teen tell tend",
  "tent term test text than that them then they thin this thus tick tide tidy tied tile",
  "till time tiny tire toad told toll tomb tone took tool tore torn tour town trap tray",
  "tree trim trip true tube tuck tune turn twin type ugly undo unit upon urge used user",
  "vain vase vast verb very vest view vine visa void vote wade wage wait wake walk wall",
  "want warm warn wash wasp wave wavy ways weak wear weed week well went were west what",
  "when whom wide wife wild will wind wing wink wipe wire wise wish with woke wolf",
  "wood wool word wore work worm worn wrap yard yarn year yell yoga yolk your zero zone",
  "zoom",
].join(" ");

const FIVE_EXTRA = [
  "bleak bleep cleat dread pants shone stats rouse thine whine bumps",
].join(" ");

const FIVE = [
  "about above abuse actor acute adapt admit adopt adult after again agent agree ahead",
  "alarm album alien alike alive allow alone along alter among angel anger angle angry",
  "ankle apart apple apply arena argue arise armor aside asset avoid awake award aware",
  "badge baker basic basin basis beach beard beast begin being belly bench berry birth",
  "black blade blame blank blast blaze bleed blend bless blind block blond blood bloom",
  "board boast boost booth bound brain brake brand brave bread break breed brick bride",
  "brief bring broad broke brook broom brown brush build built bunch burst buyer cabin",
  "cable candy canoe carry carve catch cause chain chair chalk charm chart chase cheap",
  "cheat check cheek cheer chess chest chick chief child chill chimp chirp choir chose",
  "chunk civic claim clash class clean clear clerk click cliff climb cling clock close",
  "cloth cloud clown coach coast color comic coral couch cough could count court cover",
  "crack craft crane crash crawl crazy cream crime crisp cross crowd crown crush curve",
  "cycle daily dairy daisy dance death debut decay delay depth devil diary dirty ditch",
  "dodge doing donor doubt dough dozen draft drain drama drank drawn dream dress dried",
  "drift drill drink drive drown dwarf eager eagle early earth eight elbow elder elect",
  "elite empty enemy enjoy enter entry equal error essay event every exact exist extra",
  "faint fairy faith false fancy fault feast fence fever fewer fiber field fifth fifty",
  "fight final first flame flash fleet flesh float flock flood floor flour fluid flute",
  "focus force forth forty forum found frame frank fraud fresh fried",
  "front frost fruit funny fuzzy giant given glass globe glove going grace grade grain",
  "grand grant grape graph grass grave great greed green greet grief grill grind groom",
  "gross group grown guard guess guest guide guilt habit happy harsh haste hasty hatch",
  "haunt heart heavy hedge hello hence honey honor horse hotel house human humor hurry",
  "ideal image imply index inner input irony issue ivory jelly jewel joint joker judge",
  "juice juicy jumbo kitty knife knock label labor large laser later laugh layer learn",
  "lease least leave legal lemon level lever light limit linen liner lived liver local",
  "lodge logic loose lover lower loyal lucky lunar lunch lying magic major maker maple",
  "march match mayor meant medal media melon mercy merge merit metal meter might minor",
  "minus mixed model moist money month moral motor mound mount mouse mouth movie music",
  "naive nasty naval nerve never newly night noble noise north nurse nylon oasis ocean",
  "offer often olive onion opera orbit order organ other ought outer owner oxide ozone",
  "paint panel panic paper party pasta paste patch pause peace peach pearl pedal penny",
  "phase phone photo piano piece pilot pinch pitch pizza place plain plane plant plate",
  "plaza point polar porch pound power press price pride prime print prior prize proof",
  "proud prove pupil purse queen quest quick quiet quite quote radio raise rally ranch",
  "range rapid ratio reach react ready realm rebel refer relax reply rider ridge rifle",
  "right rigid risky rival river roast robin robot rocky rough round route royal rugby",
  "ruler rural salad sauce scale scare scarf scene scent scold scone scoop score scout",
  "screw sense serve seven shade shake shall shape share shark sharp sheep sheet shelf",
  "shell shift shine shiny shirt shock shoot shore short shout shown shrug sight silly",
  "since sixth sixty skill skirt skull sleep slice slide slope small smart smell smile",
  "smoke snack snake solar solid solve sorry sound south space spare spark speak speed",
  "spell spend spice spill spine spoke spoon sport spray squad stack staff stage stain",
  "stair stake stamp stand stare start state steak steal steam steel steep steer stern",
  "stick stiff still sting stock stone stood stool store storm story stove straw strip",
  "stuck study stuff style sugar suite sunny super swamp swear sweat sweep sweet swept",
  "swift swing sword table taken taste teach teeth tempo tenth thank theft their theme",
  "there thick thief thing think third those three threw throw thumb tiger tight tired",
  "title toast today tooth topic torch total touch tough towel tower toxic trace track",
  "trade trail train trait trash treat trend trial tribe trick tried troop truck truly",
  "trunk trust truth tulip twice twist uncle under union unite unity until upper upset",
  "urban usage usual valid value vapor video villa virus visit vital vivid vocal voice",
  "voter wagon waist waste watch water weary weave weigh weird whale wheat wheel where",
  "which while white whole whose widow width witch woman women world worry worse worst",
  "worth would wound wrist write wrong wrote yacht young youth zebra",
].join(" ");

function split(text: string): string[] {
  return text.split(" ");
}

/**
 * Words that take no plural: function words, adjectives and adverbs. Everything else in
 * the three- and four-letter lists also stands for its "s" form, so "bear" brings "bears"
 * and "cat" brings "cats", which the five- and four-letter ladders need to connect.
 */
const NO_PLURAL = new Set(
  split(
    [
      "and are all any but for her his how its new nor not now off old one our out own she the too who why you yes yet was shy sly wee wet ill odd icy mad low big bad sad dry dim raw ago via",
      "able aged also away bare best both calm cozy cute dark dead deaf dear deep dull each easy else even ever evil fair fast fine firm flat free from full glad good hard high huge just keen kind lazy lone long loud many mere mild more most much must near neat next nice once only onto open over pale poor pure rare real rich rude safe same shut sick slim slow soft some sore such sure tall than that them then they thin this thus tidy tiny true ugly upon vain vast very warm wavy weak well were what when whom wide wild wise with your zero",
    ].join(" ")
  )
);

/** Words whose plural takes "es" rather than "s", which the plain rule would misspell. */
const ES_ENDING = /[sxz]$/;

function withPlurals(words: readonly string[]): string[] {
  return words.concat(
    words
      .filter((word) => !(NO_PLURAL.has(word) || ES_ENDING.test(word)))
      .map((word) => `${word}s`)
  );
}

const BASE_THREE = split(THREE);
const BASE_FOUR = split(`${FOUR} ${FOUR_EXTRA}`);

/** The hand-picked words, before their plurals are added. */
export const EVERYDAY_BASE: Readonly<Record<number, readonly string[]>> = {
  2: split(TWO),
  3: BASE_THREE,
  4: BASE_FOUR,
  5: split(`${FIVE} ${FIVE_EXTRA}`),
};

/** Everyday words by length, with the plural of every noun and verb. */
export const EVERYDAY_WORDS: Readonly<Record<number, readonly string[]>> = {
  2: split(TWO),
  3: BASE_THREE,
  4: [...new Set([...BASE_FOUR, ...withPlurals(BASE_THREE)])],
  5: [
    ...new Set([...split(`${FIVE} ${FIVE_EXTRA}`), ...withPlurals(BASE_FOUR)]),
  ],
};

/** Whether an everyday list exists for words of this length. */
export function hasEverydayWords(length: number): boolean {
  return EVERYDAY_WORDS[length] !== undefined;
}
